









	import Vue from 'vue';
    import RaidToolbarComp from "../components/raid/RaidToolbarComp.vue";

    export default Vue.extend({
        name: "RaidPage",
        components: { RaidToolbarComp },
        created: function(): void {
            if (!this.$vStore.getters.raid) {
				window.location.href = '/#/raids';
			}
        }
    })
